import { defineCustomElements } from '@ionic/pwa-elements/loader'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'
import { initNetworkStatus } from 'App/ServiceCenter/store/networkStore'
import { initI18n } from 'i18n/i18n'
import ReactDOM from 'react-dom/client'
import { hubConnectorSettings, loadDefaultHubConnectorSettings } from 'settings/hubConnectorSettings'
import 'settings/mantine-baseline-overrides.css'
import 'settings/mantine-overrides.css'
import { loadStores } from 'stores/_utils/loadStores'
import { initDeviceScreenOrientation } from 'stores/smallStore/smallStore'
import { initChunkLoadErrorRecovery } from 'utils/initChunkLoadErrorRecovery'
import { checkForSemiosClassicMigration } from 'utils/semiosClassicMigration/checkForSemiosClassicMigration'
import { isSemiosClassicMigrationEnabled } from 'utils/semiosClassicMigration/isSemiosClassicMigrationEnabled'
import { App } from './App/App'
import './hubspot'
import './ionicStorage'
import './sentry'
import './windowObjectAddons'

// Note: consider the calling code that uses this containerId if we change it at any point
export const containerId = 'app'

// Registered before the app renders so a stale chunk hit during startup is
// recovered too, not just ones from later user navigation.
initChunkLoadErrorRecovery()

if (isSemiosClassicMigrationEnabled) {
  checkForSemiosClassicMigration()
}

loadDefaultHubConnectorSettings()

loadStores()
  .then(() => initI18n())
  .then(() => initNetworkStatus(hubConnectorSettings.apiUrl))
  .then(() => initDeviceScreenOrientation())
  .finally(() => {
    ReactDOM.createRoot(document.getElementById(containerId) as HTMLElement).render(<App />)
  })

// Call the element loader after the app has been rendered the first time
defineCustomElements(window)
